// src/components/UpgradeModal.jsx
import { Fragment } from "react";
import react, { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Dialog, Transition } from "@headlessui/react";

export default function UpgradeModal({ open, onClose }) {
  const [paddleReady, setPaddleReady] = useState(false);
  const navigate = useNavigate();
  const email = "test@test.com";

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://cdn.paddle.com/paddle/v2/paddle.js";
    script.async = true;

    script.onload = () => {
      if (window.Paddle) {
        window.Paddle.Environment.set("sandbox");

        window.Paddle.Initialize({
          token: "test_21d1cf74b8f979932dc60c53517",
          eventCallback: (data) => {
            console.log("Paddle event:", data);

            if (data.name === "checkout.completed") {
              console.log("✅ Payment complete. Redirecting...", email);
              // 👇 Close the Paddle modal
              if (window.Paddle?.Checkout) {
                window.Paddle.Checkout.close();
              }
              navigate("/profile", {
                // replace: true,
                state: { upgradeSuccess: true },
              });
            }
          },
        });

        setPaddleReady(true);
      }
    };

    document.body.appendChild(script);
  }, []);

  const handleCheckout = () => {
    onClose();
    if (!window.Paddle || !paddleReady) return;

    // Define items
    const items = [{ priceId: "pri_01jvvbxgfsfbyvgagftbbt8m25", quantity: 1 }];

    // Define customer info
    const customer = {
      email: "sam@example.com",
      address: {
        countryCode: "US",
        postalCode: "10021",
      },
    };

    // Open Paddle Checkout
    window.Paddle.Checkout.open({
      items,
      customer,
    });
  };
  return (
    <Transition show={open} as={Fragment}>
      <Dialog as="div" className="fixed inset-0 z-50" onClose={onClose}>
        {/* Overlay */}
        <div className="fixed inset-0 bg-black bg-opacity-50" />

        {/* Centering */}
        <div className="fixed inset-0 flex items-center justify-center p-4">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-200"
            enterFrom="opacity-0 scale-95"
            enterTo="opacity-100 scale-100"
            leave="ease-in duration-150"
            leaveFrom="opacity-100 scale-100"
            leaveTo="opacity-0 scale-95"
          >
            <div className="w-full max-w-2xl bg-white rounded-2xl shadow-xl p-6 relative">
              {/* Close Button */}
              <button
                onClick={onClose}
                className="absolute right-4 top-4 text-gray-500 hover:text-gray-800"
              >
                ✕
              </button>

              {/* Title */}
              <Dialog.Title className="text-2xl font-bold text-center mb-6">
                Upgrade Your Plan 🚀
              </Dialog.Title>

              {/* Plans */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {/* Starter Plan */}
                <div className="border rounded-xl p-6 flex flex-col justify-between">
                  <div>
                    <h3 className="text-xl font-semibold mb-2">Starter</h3>
                    <p className="text-gray-600 mb-4">$12/month</p>
                    <ul className="space-y-2 text-sm text-gray-700">
                      <li>✅ Unlimited tweet generations</li>
                      <li>✅ Basic hashtag booster</li>
                      <li>✅ Export to Twitter & Threads</li>
                    </ul>
                  </div>
                  <button
                    onClick={() => handleCheckout()}
                    className="mt-6 w-full bg-indigo-600 text-white py-2 rounded-lg font-semibold hover:bg-indigo-500"
                  >
                    Upgrade to Starter
                  </button>
                </div>

                {/* Pro Plan */}
                <div className="border-2 border-indigo-600 rounded-xl p-6 flex flex-col justify-between">
                  <div>
                    <h3 className="text-xl font-semibold mb-2">Pro</h3>
                    <p className="text-gray-600 mb-4">$29/month</p>
                    <ul className="space-y-2 text-sm text-gray-700">
                      <li>✅ Everything in Starter</li>
                      <li>✅ Advanced AI optimization</li>
                      <li>✅ Team collaboration</li>
                      <li>✅ Priority support</li>
                    </ul>
                  </div>
                  <button
                    onClick={() => handleCheckout()}
                    className="mt-6 w-full bg-indigo-600 text-white py-2 rounded-lg font-semibold hover:bg-indigo-500"
                  >
                    Upgrade to Pro
                  </button>
                </div>
              </div>

              <p className="text-center text-gray-500 text-sm mt-6">
                Cancel anytime • Secure payments
              </p>
            </div>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition>
  );
}
